import { enableProdMode, provideZonelessChangeDetection } from '@angular/core';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { platformBrowser } from '@angular/platform-browser';
import 'moment/locale/de';

if (environment.production) {
    enableProdMode();
}

platformBrowser().bootstrapModule(
    AppModule,
    {
        applicationProviders: [
            provideZonelessChangeDetection(),
        ],
    },
).catch(err => console.log(err));
